export default function (number, minimumFractionDigits = 0) {
    if (isNaN(number) || number === null) {
        return number;
    }

    let decimalPlaces = 0;
    if (number < 10) {
        decimalPlaces = 2;
    } else if (number < 100){
        decimalPlaces = 1;
    }
    return number.toLocaleString('en', {
        maximumFractionDigits: decimalPlaces,
        minimumFractionDigits: Math.min(decimalPlaces, minimumFractionDigits)
    });
}
